import {ROUTENAMES} from '../../consts/const.enum';
import Router from 'vue-router';
import Vue from 'vue';
import './services/developer.service';

export function setupDeveloper (router: Router): void {
  Vue.component('ThemeSwitcher', () => import('@/components/developer/components/ThemeSwitcher.vue'));

  router.addRoute( {
    path: '/' + ROUTENAMES.DEVELOPER,
    meta: {
      name: ROUTENAMES.DEVELOPER,
    },
    component: () => import( './views/Developer.vue'),
    children: [
      {
        path: '',
        name: ROUTENAMES.DASHBOARD,
        component: () => import('./views/Dashboard.vue'),
      },
      {
        path: ROUTENAMES.STATE,
        name: ROUTENAMES.STATE,
        component: () => import('./views/State.vue'),
      },
      {
        path: ROUTENAMES.CONFIG,
        name: ROUTENAMES.CONFIG,
        component: () => import('./views/Config.vue'),
      }
    ]
  });



}
